module.exports = __webpack_public_path__ + "static/media/33.f4e172a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/33.jpg
// module id = 723
// module chunks = 0